import { Box } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import CustomCard from '@ui-components/Card/CustomCard';
import CustomTextField from '@ui-components/TextField/CustomTextField';
import CustomButton from '@ui-components/Button/CustomButton';
import CustomTypography from '@ui-components/Typography/CustomTypography';
import CustomLink from '@ui-components/Link/CustomLink';
import CustomDivider from '@ui-components/Divider/CustomDivider';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import '@utils/utilities.css';
import type { FacilityLogin } from '../../API/services/loginServices';

const initialValues: FacilityLogin = {
  username: '',
  password: '',
};

export interface LoginBody {
  handleSubmitData: (data: FacilityLogin) => void;
  onForgotPassword: () => void;
}

const validationSchema = Yup.object({
  username: Yup.string().required('Username/Email is required'),
  password: Yup.string().required('Password is required'),
});

const Login = ({ onForgotPassword, handleSubmitData }: LoginBody) => {
  const handleForgotPassword = () => {
    onForgotPassword();
  };

  const handleLogin = (values: FacilityLogin) => {
    sessionStorage.removeItem('pendingMfaUser');
    handleSubmitData(values);
  };

  return (
    <Box>
      <Formik
        initialValues={initialValues}
        validateOnMount={true}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleLogin(values);
        }}
      >
        {({ setFieldValue, values, handleSubmit, errors, touched }) => (
          <Grid2 container justifyContent="center">
            <CustomCard
              className="p-16 card-width login-form"
              id="cardWithoutImage"
            >
              <CustomTypography
                className="pb-12 mt-40"
                id="demo-h2"
                variant="h3"
              >
                Facility Sign In
              </CustomTypography>
              <CustomTypography
                id="demo-h2"
                variant="body2"
                color="textSecondary"
                className="pb-32"
              >
                Please enter your username/email and password to continue.
              </CustomTypography>

              <Box display="flex" justifyContent="center" className="pb-16">
                <Grid2 size={{ xs: 12, sm: 12, md: 12 }}>
                  <CustomTextField
                    id="txtName"
                    placeholder="Username/Email"
                    size="small"
                    type="username"
                    name="enter-user-name"
                    className="input-width"
                    value={values.username}
                    onChange={(e) => setFieldValue('username', e.target.value)}
                  />
                  {errors.username && touched.username && (
                    <CustomTypography
                      id="error-username"
                      variant="body3"
                      color="error"
                      className="float-left multiline-error"
                    >
                      <ErrorMessage name="username" />
                    </CustomTypography>
                  )}
                </Grid2>
              </Box>
              <Box display="flex" justifyContent="center" className="pb-8">
                <Grid2 size={{ xs: 12, sm: 12, md: 12 }}>
                  <CustomTextField
                    id="txtPassword"
                    variant="outlined"
                    placeholder="Password"
                    name="enter-password"
                    value={values.password}
                    onChange={(e) => setFieldValue('password', e.target.value)}
                    size="small"
                    type="password"
                    className="mr-10"
                    isPassword={true}
                  />
                  {errors.password && touched.password && (
                    <CustomTypography
                      id="error-password"
                      variant="body3"
                      color="error"
                      className="float-left multiline-error"
                    >
                      <ErrorMessage name="password" />
                    </CustomTypography>
                  )}
                </Grid2>
              </Box>
              <Box display="flex" className="pb-16">
                <Grid2 size={{ xs: 12, sm: 12, md: 12 }}>
                  <CustomLink
                    className="forgot-link"
                    id="demo-link"
                    color="info"
                    variant="h6"
                    underline="none"
                    onClick={handleForgotPassword}
                  >
                    Forgot Password
                  </CustomLink>
                </Grid2>
              </Box>
              <Box display="flex" justifyContent="center" className="pb-24">
                <Grid2 size={{ xs: 12, sm: 12, md: 12 }}>
                  <CustomButton
                    id="btnLarge"
                    variant="contained"
                    className="button-width button-height button-font-size"
                    onClick={() => handleSubmit()}
                  >
                    Login
                  </CustomButton>
                </Grid2>
              </Box>
              <CustomDivider />
              <CustomTypography
                id="demo-h2"
                variant="body2"
                color="textSecondary"
                className="pt-24"
              >
                Having Difficulty? Please call
              </CustomTypography>
              <CustomTypography id="demo-h2" variant="h6">
                (855) 797-7879
              </CustomTypography>
            </CustomCard>
          </Grid2>
        )}
      </Formik>
    </Box>
  );
};
export default Login;
